import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { IntegrationTrafficModal } from '@app/features/scope-overview/components/integration-traffic/integration-traffic.component'
import { ChangeRequestIntegrationModalConfig } from '../../model/change-request-integration-modal-config'
import { ScopeTraffickingService } from '@app/features/scope-overview/service/scope-trafficking.service'
import { SnackbarService } from '@shared/utils/snackbar.service'
import { WebsocketService } from '@shared/services/websocket.service'
import { ExchangeRateService } from '@shared/services/exchange-rate.service'
import { ChangeRequestService } from '../../service/change-request.service'
import { TrafficReportModel, TrafficReportObject } from '@app/features/scope-overview/model/traffic-report-model'
import { SNACKBAR_LENGTH_SHORT, SnackbarEventType } from '@shared/utils/snackbar.service'
import { SharedModule } from '@app/shared/shared.module'
import { PipesModule } from '@app/shared/pipe/index.module'

@Component({
  selector: 'change-request-traffic-modal',
  standalone: true,
  imports: [CommonModule, PipesModule, MatDialogModule, SharedModule],
  templateUrl: '../../../components/integration-traffic/integration-traffic.component.html',
  styleUrls: ['../../../components/integration-traffic/integration-traffic.component.scss'],
})
export class ChangeRequestTrafficModal extends IntegrationTrafficModal {
  constructor(
    @Inject(MAT_DIALOG_DATA) public override data: ChangeRequestIntegrationModalConfig,
    dialogRef: MatDialogRef<ChangeRequestTrafficModal>,
    dialog: MatDialog,
    traffickingService: ScopeTraffickingService,
    snackbarService: SnackbarService,
    webSocketService: WebsocketService,
    exchangeRateService: ExchangeRateService,
    private changeRequestService: ChangeRequestService
  ) {
    super(data, dialogRef, dialog, traffickingService, snackbarService, webSocketService, exchangeRateService)
  }

  override trafficScope() {
    this.loading = true
    const selectedIntegrationNames = this.getSelectedIntegrations()
    const exchangeRate = this.exchangeRateService.exchangeRate

    this.changeRequestService
      .trafficChangeRequest(this.data.scopeId, this.data.changeRequestId, selectedIntegrationNames, exchangeRate)
      .subscribe({
        next: (response) => {
          const that = this
          this.webSocketService.connect()
          this.webSocketService.registerTrafficReportReceiver(
            response.subId,
            function (reportEvent: TrafficReportModel) {
              const reportEventJson = JSON.parse(reportEvent.object)
              const reportObject = reportEventJson as TrafficReportObject
              that.reportMessageList.push(reportObject)
            }
          )
          return response
        },
        error: (error) => {
          console.error(error)
          this.loading = false
          this.snackbarService.showSnackbar(
            `An error occurred during data export`,
            SNACKBAR_LENGTH_SHORT,
            SnackbarEventType.ERROR
          )
        },
      })
  }
}
